export default "__VITE_ASSET__1rsxgi5o__"